import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { Observable, of } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { ExperimentsService } from '../experiments/experiments.service';
import { QuestionnaireService } from '../questionnaire/questionnaire.service';
import { WindowRef } from '../windowRef.service';

@Injectable()
export class CanActivatePostCoQxGuard implements CanActivate {

  constructor(
    private router: Router,
    private questionnaireService: QuestionnaireService,
    private cookieService: CookieService,
    private environmentService: EnvironmentService,
    private experimentService: ExperimentsService,
    private windowRef: WindowRef
  ) { }

  // timestringExists() {
  //   if (this.userService.user.timestring === undefined || !this.userService.user.timestring || this.userService.user.timestring.length === 0) {
  //     this.userService.user.timestring = this.cookieService.get(this.environmentService.getTimestringCookie());
  //   }
  //   return (this.userService.user.timestring && this.userService.user.timestring.length > 0);
  // }

  urlTimestringForMobileExists(activatedRouteSnapshot) {
    if (activatedRouteSnapshot.queryParams && activatedRouteSnapshot.queryParams.TIMESTRING &&
      activatedRouteSnapshot.queryParams.mobile_app) {
      this.questionnaireService.llc.isMobileApp = true;
      const cookieDomain = window.location.hostname === 'localhost' ? 'localhost' : 'legalzoom.com';
      const cookieOptions: CookieOptions = { domain: cookieDomain };
      this.cookieService.put(
        this.environmentService.getTimestringCookie(),
        activatedRouteSnapshot.queryParams.TIMESTRING,
        cookieOptions
      );
      // this.userService.user.timestring = activatedRouteSnapshot.queryParams.TIMESTRING;
      return true;
    }
    return false;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    if (next && next.queryParams && next.queryParams.mobile_app) { // 'mobile_app' set via mobile application
      this.questionnaireService.llc.isMobileApp = true;
    }


    // if (!this.timestringExists()) {
    //   if (!this.urlTimestringForMobileExists(next)) {
    //     this.windowRef.nativeWindow.location.href = PagePath.LLCLandingPage;
    //     return of(true); // false didn't work with safari on Mac
    //   }
    // }
    if (next && next.queryParams && next.queryParams.uo && !this.questionnaireService.llc.currentView) {
      this.questionnaireService.llc.bFunnelTest = this.experimentService.GetBFunnelTestValueForQ2Crosssells();
      this.questionnaireService.llc.bShowPriceTest = this.experimentService.GetBShowPriceTestValueForQ2Crosssells();
      this.questionnaireService.llc.bShowPriceTest1 = this.experimentService.GetBShowPriceTest1ValueForQ2Crosssells();
    } else {
      this.questionnaireService.llc.bFunnelTest = this.experimentService.GetBFunnelTestValue();
      this.questionnaireService.llc.bShowPriceTest = this.experimentService.GetBShowPriceTestValue();
      this.questionnaireService.llc.bShowPriceTest1 = this.experimentService.GetBShowPriceTest1Value();
    }
    return of(true);
  }
}
